export default __webpack_public_path__ + "static/media/stories-image-3.9d4f3d32.png";